const formatPCN = (pcn) => (
  pcn.toUpperCase().replace(/\s+/g, '')
)

const formatReg = (reg) => (
  reg.toUpperCase().replace(/\s+/g, '')
)

const formatEmail = (email) => (
  email.toLowerCase()
)

const helpers = {
  formatPCN,
  formatReg,
  formatEmail
}

export default helpers



// WEBPACK FOOTER //
// ./src/helpers.js